const React = require('react');
const CircularProgress = require('@material-ui/core/CircularProgress').default;

/*
  Here is a hack to force font loading.
  "A"
*/
module.exports = (props) => {
  const {
    children,
  } = props;
  return (
    <div
      {...props}
      className={'abs s layoutRow fvaC fhaC ' + (props.className || '')}
    >
      <div>
        {children ? (<div className="h31"/>) : null}
        <div className="layoutRow fvaC fhaC CircularProgress cF">
          <CircularProgress
            className="mhA dB*2 cCT*2"
          />
        </div>
        <div className="abs s ff$2 o0 z-10">
          <span className="fw3">A</span>
          <span className="fw4">A</span>
          <span className="fw5">A</span>
          <span className="fw6">A</span>
          <span className="fw7">A</span>
          <span className="fw8">A</span>
          <span className="fw9">A</span>
        </div>
        <div className="abs s ff$1 o0 z-10">
          <span className="fw3">A</span>
          <span className="fw4">A</span>
          <span className="fw5">A</span>
          <span className="fw6">A</span>
          <span className="fw7">A</span>
          <span className="fw8">A</span>
          <span className="fw9">A</span>
        </div>
        {
          children ? (<div
            className="pt15 h31 f14 tc"
          >{children}</div>) : null
        }
      </div>
    </div>
  );
};
